<template>
    <rkm-tabs>
        <rkm-tab
            active
            title="Enviadas"
        >
            <Enviada />
        </rkm-tab>

        <rkm-tab title="Recebidas">
            <Recebida />
        </rkm-tab>
    </rkm-tabs>
</template>

<script>
// Components.
import Enviada from './components/enviada/List'
import Recebida from './components/recebida/List'

export default {
    components: { Enviada, Recebida },
}
</script>